import bg from '../assets/bg.png';
import logo from '../assets/logo.png';
import deadpool from '../assets/deadpool.png';
import project from '../assets/stockTracker2.png';

export default {bg, logo, deadpool, project};